// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"570":"viwes-blank-page","625":"views-admin","957":"views-app"}[chunkId] || chunkId) + "." + {"570":"16af0842","618":"d50f08eb","625":"811a5ba3","791":"5bcbb560","957":"ff74b648"}[chunkId] + ".chunk.js";
};